import { apiConstructor } from '../../api/ConstructorApi'


let flaps = []

function initFlaps() {
    return new Promise((resolve, reject) => {
        apiConstructor.getFlaps()
        .then(res => {
            flaps = res.data 
            resolve(true)
        })
        .catch(res => {
            reject(false)
        })
    })
}

export {flaps, initFlaps}